// Copyright (c) 2017 Deere & Company

import ReimbursementSummaryClaimsData, {getDefaultState as getReimbursementSummaryClaimsDataDefaultState} from './claim-summary';

import t from 'tcomb';

const State = t.struct({
    data: ReimbursementSummaryClaimsData
}, 'State');

export const getDefaultState = () =>
    new State({
        data: getReimbursementSummaryClaimsDataDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/claims/state/index.js